
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outdoors/[[...page]]",
      function () {
        return require("private-next-pages/outdoors/[[...page]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outdoors/[[...page]]"])
      });
    }
  